/* eslint-disable */
require('eventsource-polyfill')
var hotClient = require('webpack-hot-middleware/client?noInfo=true&reload=true')

hotClient.subscribe(function (event) {
  if (event.action === 'reload') {
    window.location.reload()
  }
})



//////////////////
// WEBPACK FOOTER
// ./build/dev-client.js
// module id = 562
// module chunks = 0